import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { GetStartedService } from '../../../services/get-started.service';

@Component({
  selector: 'app-get-started',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './get-started.html',
  styleUrl: './get-started.css',
})
export class GetStarted {
  private getStartedService = inject(GetStartedService);
  private fb = inject(FormBuilder);
  private cdr = inject(ChangeDetectorRef);

  form: FormGroup = this.fb.group({
    role: ['School counselor'],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    school: [''],
    message: ['', Validators.required],
  });

  loading = false;
  submitted = false;
  errorMsg = '';

  /**
   * Validates and submits the inquiry form via GetStartedService.
   * Marks all fields touched on invalid to trigger validation messages.
   */
  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.errorMsg = '';

    this.getStartedService.sendInquiry(this.form.value).subscribe({
      next: () => {
        this.loading = false;
        this.submitted = true;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        this.errorMsg = err?.error?.message || 'Something went wrong. Please try again.';
      },
    });
  }
}
